import React, { useRef } from "react";
import styled from "styled-components";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "", // Replace with your service ID
        "", // Replace with your template ID
        formRef.current,
        "", // Replace with your public key
      )
      .then(
        (result) => {
          console.log("SUCCESS!", result.text);
          alert("Message sent successfully!");
          formRef.current.reset();
        },
        (error) => {
          console.error("FAILED...", error.text);
          alert("Failed to send message. Please try again.");
        },
      );
  };

  return (
    <Container>
      <div className="wrapper">
        <div className="left">
          <h1>Per cdo pyetje qe keni, na konkaktoni ketu!</h1>
          <p>Jemi ketu per jju!</p>
        </div>
        <form>
          <input
            type="text"
            name="full_name"
            placeholder="Emri i plote"
            required
          />
          {/* <input type="text" name="social_handles" placeholder="Social Handles" /> */}
          <input type="tel" name="phone" placeholder="Numri i telefonit" />
          <input
            type="email"
            name="email"
            placeholder="Email Adresa"
            required
          />
          <textarea
            name="message"
            rows={5}
            placeholder="Mesazhi"
            required
          ></textarea>
          <button type="submit">Dergo</button>
        </form>
      </div>
    </Container>
  );
};
const Container = styled.div`
  padding: 12em 10%;
  .wrapper {
    img {
      position: absolute;
      opacity: 0.1;
      width: 100%;
      left: 0;
      padding: 0 20%;
      /* margin: auto; */
      /* display: flex; */
      filter: brightness(0.7) contrast(0.3);
    }
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
    .left {
      width: 47%;
      z-index: 10;
      h1 {
        line-height: 1em;
        font-size: 5vw;
        font-weight: 400;
      }
      p {
        margin-top: 2em;
      }
    }
    form {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 99;
      gap: 10px;
      input,
      textarea {
        background: linear-gradient(135deg, #6494dd 0%, #abcdec 100%);
        backdrop-filter: blur(10px);
        border-radius: 20px;
        color: white;
        font-family: "Comfortaa";
        font-size: 20px;
        padding: 25px 25px;
        width: 100%;
        border: none;
        &::placeholder {
          color: #bebebe;
        }
      }
      button {
        font-family: "Comfortaa";
        font-size: 24px;
        border: none;
        margin-top: 10px;
        border-radius: 20px;
        padding: 15px 25px;
        cursor: pointer;
      }
    }
  }
  @media (max-width: 1300px) {
    padding: 7em 6%;
    .wrapper {
      .left {
        width: 40%;
      }
      form {
        width: 55%;
      }
    }
  }
  @media (max-width: 1000px) {
    padding: 7em 6%;
    .wrapper {
      flex-direction: column;
      .left {
        width: 100%;
        text-align: center;
        h1 {
          font-size: 12vw;
        }
      }
      form {
        width: 95%;
      }
    }
  }
`;

export default Contact;
